<!-- 公众号订单 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<!-- 2023-1-9日期范围改为后端控制，在用户列表设置 -->
			<!-- <div v-if="role_control.includes(1)" class="screen-box"> -->
			<div class="screen-box">
				<div class="screen-label">订单日期</div>
				<a-range-picker style="width:260px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			<!-- <div v-else class="screen-box">
				<div class="screen-label">订单日期</div>
				<a-range-picker style="width:240px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" 
				:disabledDate="DateControl" />
			</div> -->
			
			<div v-show="Object.keys(filterList.op_id).length > 0" class="screen-box">
				<div class="screen-label">投手</div>
				
				<a-select
					mode="multiple"
					style="min-width: 180px"
					placeholder="请选择投手"
					@change="handleChangeTS"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.op_id.list" :key="index" :value="item.key" >
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">渠道</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择渠道"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					showSearch
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.channel_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">公众号</div>
				
				<moreSelect
				 ref="getGzhSelect"
				:placeholder="'请选择公众号'"
				:select_mode="'multiple'"
				@handleChangeSelect="handleChangeB"
				></moreSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">OpenId</div>
				<a-input v-model="r_openid" allowClear placeholder="请输入" style="width: 260px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">注册时间</div>
				<a-range-picker
					style="width: 360px"
					:locale="locale" 
				    :show-time="{ format: 'HH:mm:ss' }"
				    format="YYYY-MM-DD HH:mm:ss"
				    :placeholder="['开始时间', '结束时间']" 
				    @change="onChangeDateC"
				    @ok="onDateC_ok" 
				/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">订单ID</div>
				<a-input v-model="r_order_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">订单金额</div>
				<div style="display: flex;align-items: center;">
					<a-input-number v-model="r_start_money" id="inputNumber" style="width:110px;" @change="onChangeNumberS" />
					<div style="margin: 0 10px;">至</div>
					<a-input-number v-model="r_end_money" id="inputNumber1" style="width:110px;" @change="onChangeNumberE" />
				</div>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否为注册当天订单</div>
				<a-select :value="r_is_today_order" style="width: 150px;" 
				 @change="handleChangeE" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否首充</div>
				<a-select :value="r_is_again" style="width: 150px;" 
				 @change="handleChangeG" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="0">是</a-select-option>
					<a-select-option value="1">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				
				<a-select
					style="min-width: 160px"
					placeholder="请选择推广平台"
					:filter-option="filterOption"
					@change="handleChangeC"
					:getPopupContainer="getsPopupContainer" 
					showSearch
					allowClear
				  >
					<a-select-option v-for="(value,key) in PlatformData" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">计划ID(单元ID)</div>
				<a-input v-model="r_ad_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">创意ID</div>
				<a-input v-model="r_creativeid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Promotion_id</div>
				<a-input v-model="r_promotion_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Project_id</div>
				<a-input v-model="r_project_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
		
			
			<div class="screen-box">
				<div class="screen-label">落地页ID</div>
				<a-input v-model="r_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配落地页</div>
				<a-select :value="r_is_has_link" style="width: 150px;" 
				 @change="handleChangeF" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否回传</div>
				<a-select :value="r_has_report" style="width: 150px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<a-button @click="exportButton" type="primary" icon="download" class="screen-box" >导出</a-button>
			<a-button @click="custtom_visible = true" class="screen-box" icon="unordered-list" >自定义列</a-button>
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
				
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default',}" 
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type != 'province' && z_tem.type != 'is_again' && z_tem.type != 'from_type' && z_tem.type != 'mp_campaign_id' && z_tem.type != 'report_id_type' && z_tem.type != 'report_id' && z_tem.type != 'cz'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- IP地址 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'province'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.province}} {{item.city}} {{item.county}}
				</div>
				<!-- 是否首充 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'is_again'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.is_again == 0?'是':'否'}}
				</div>
				<!-- 推广媒体 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'from_type'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.from_type}}
					<div v-if="item.is_mp">MP</div>
					<div v-if="item.is_adq">ADQ</div>
				</div>
				<!-- 计划ID(单元ID) -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'mp_campaign_id'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.is_mp == 1 || item.is_adq == 1">
						{{item.mp_campaign_id}}
					</div>
					<div v-else>
						{{item.ad_id}}
					</div>
				</div>
				<!-- 匹配落地页/点击表 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'report_id_type'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.report_id_type | landPageFilter}}
				</div>
				<!-- 落地页/点击表ID -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'report_id'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.report_id || ''}}
				</div>
				<!-- 操作 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'cz'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<!-- 在不显示 手动回传MP 、手动回传ADQ的前提下，只要有report_id，就有手动回传按钮 -->
					<!-- 先判断是否有report_id，report_id没有值则显示自定义回传。有的话看is_mp、is_adq是否为1，如果是的话就显示对应的MP、ADQ手动回传按钮，没有的话就显示手动回传(后端会自动判断平台) -->
					<div v-if="item.has_report == '未回传' && item.report_id && item.is_mp != 1 && item.is_adq != 1" @click="HcTdTable(item,0)" style="color: #62a8ea;cursor: pointer;">手动回传</div>
					<div v-else-if="item.has_report == '未回传' && item.is_mp == 1" @click="HcTdTable(item,2)" style="color: #62a8ea;cursor: pointer;">手动回传MP</div>
					<div v-else-if="item.has_report == '未回传' && item.is_adq == 1" @click="HcTdTable(item,3)" style="color: #62a8ea;cursor: pointer;">手动回传ADQ</div>
					
					<div v-else-if="item.has_report == '未回传' && !item.report_id" @click="HcTdTable(item,1)" style="color: #62a8ea;cursor: pointer;">自定义回传</div>
					<!-- report_id(订单匹配上的点击id)存在，is_mp = 1或is_adq = 1 ，显示手动回传 -->
				</div>
			</template>
			
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" 
		:style="{'width': body_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" 
		:table_null_width="body_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 手动回传mp，adq -->
	<a-modal :visible="hc_mp_adq_visible" title="确认要回传？" @ok="hcMpAdqOk" @cancel="hcMpAdqCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_mp_adq_loading">
	    <div>ID：{{hc_mp_adq_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">推广平台</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
				<a-select-option value="4">微博点击检测</a-select-option>
				<a-select-option value="6">快手落地页</a-select-option>
			</a-select>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">推广平台点击表</div>
			<div @click="goLPzj" style="cursor: pointer;">点击前往 - {{h_report_id_type | jumpUrlFilter}}用户表，寻找点击id</div>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">点击表ID</div>
	    	<a-input v-model="h_report_id" placeholder="请输入点击表ID" style="width: 290px;"  />
	    </div>
	</a-modal>
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列" @ok="customTd" @cancel="customTd" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			<template  v-for="(d_tem,d_ndex) in customCheckboxData">
				<div class="custom-title">
					<a-checkbox @change="checkboxCustom($event,d_tem)"
					:checked="d_tem.custom_checkbox" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
					{{d_tem.label}}
				</div>
				<div class="custom-cell-box">
					<template v-for="(item,index) in rableTitle">
						<div v-if="(d_tem.showTitle.indexOf(item.type) > -1)" 
						:key="item.type" style="width:240px;">
							<a-checkbox @change="onChangeSJ($event,index,d_tem)"
							:checked="item.show_control" style="margin-right: 5px;margin-bottom:10px;">
								{{item.title}}
							</a-checkbox>
						</div>
					</template>
				</div>
			</template>
			
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, landPagePlatform, orderGzhList, orderGzhReport, orderGzhCustomReport, orderGzhExport, orderGzhMpAdq } from '@/request/api'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
export default {
	name: 'orderGzh_',
	components: {
		moreSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
				op_id: {},
			}, 
			PlatformData: {},
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:100, type:"id", sort_status:0, sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"渠道", width:100, type:"channel_name", sort_status:0, sort_control: false, show_control: true,},
				{title:"公众号", width:120, type:"gzh_name", sort_status:0, sort_control: false, show_control: true,},
				
				{title:"用户OpenId", width:180, type:"openid", sort_status:0, sort_control: false, show_control: true,},
				{title:"Unionid", width:180, type:"unionid", sort_status:0, sort_control: false, show_control: true,},
				{title:"注册时间", width:150, type:"reg_time", sort_status:0, sort_control: true, show_control: true,},
				{title:"用户注册IP", width:130, type:"user_ip", sort_status:0, sort_control: false, show_control: true,},
				{title:"IP地址", width:130, type:"province", sort_status:0, sort_control: false, show_control: true,},
				{title:"订单ID", width:170, type:"order_id", sort_status:0, sort_control: false, show_control: true,},
				{title:"订单金额(元)", width:120, type:"order_money", sort_status:0, sort_control: false, show_control: true,},
				{title:"订单时间", width:150, type:"order_time", sort_status:0, sort_control: true, show_control: true,},
				{title:"注册当天订单", width:120, type:"is_today_order", sort_status:0, sort_control: false, show_control: true,},
				{title:"是否首充", width:100, type:"is_again", sort_status:0, sort_control: false, show_control: true,},
				{title:"推广媒体", width:120, type:"from_type", sort_status:0, sort_control: false, show_control: true,},
				{title:"计划ID(单元ID)", width:120, type:"mp_campaign_id", sort_status:0, sort_control: false, show_control: true,},
				{title:"创意ID", width:120, type:"creativeid", sort_status:0, sort_control: false, show_control: true,},
				
				{title:"Promotion_id", width:130, type:"promotion_id", sort_status:0, sort_control: false, show_control: true,}, // 巨量推广id
				{title:"Project_id", width:130, type:"project_id", sort_status:0, sort_control: false, show_control: true,}, // 巨量活动id
				
				{title:"匹配落地页/点击表", width:130, type:"report_id_type", sort_status:0, sort_control: false, show_control: true,},
				{title:"落地页/点击表ID", width:120, type:"report_id", sort_status:0, sort_control: false, show_control: true,},
				{title:"落地页ID", width:120, type:"link_id", sort_status:0, sort_control: false, show_control: true,},
				{title:"匹配指标", width:100, type:"match_type_text", sort_status:0, sort_control: false, show_control: true,},
				{title:"是否回传", width:100, type:"has_report", sort_status:0, sort_control: false, show_control: true,},
				{title:"正式投放回传原因：付费1", width:190, type:"pass_reason", sort_status:0, sort_control: false, show_control: true,},
				{title:"回传时间", width:190, type:"report_pay_time", sort_status:0, sort_control: false, show_control: true,},
				{title:"补回传原因：付费2", width:190, type:"supply_active_pay", sort_status:0, sort_control: false, show_control: true,},
				{title:"操作", width:160, type:"cz", show_control: true,},
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_channel_id: "", // 渠道id
			r_gzh_id: "", // 公众号id
			r_platform:"", // 推广媒体
			r_order_id: "", // 订单ID
			r_link_id: "", // 落地页ID
			r_creativeid: "", // 创意ID
			r_ad_id: "", // 计划ID(单元ID)
			r_has_report: undefined, // 是否回传
			r_is_today_order: undefined, // 是否为注册当天订单
			r_is_has_link: undefined, // 是否匹配落地页
			r_is_again: undefined, // 是否首充
			
			r_promotion_id: null,
			r_project_id: null,
			r_openid: null,
			
			r_admin_id: [], // 投手
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			// 手动回传mp，adq
			hc_mp_adq_id: "",
			hc_mp_adq_visible: false,
			hc_mp_adq_loading: false,
			
			role_control: [], // 用户权限控制
			
			regStartDate: "", // 开始注册时间
			regEndDate: "", // 结束注册时间
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			r_start_money: null, // 开始-金额区间
			r_end_money: null, // 结束-金额区间
			
			// 公众号下拉框-带下滑加载-带搜索
			gzhFilterData: [], // 公众号下拉选择框的数据
			gzhFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			gzhFilterSearch: [], // 下拉框搜索后的存放数据
			gzh_page: 0,
			gzh_limit: 50,
			
			custtom_visible: false, // 自定义列
			sticky_index: 2,
			customCheckboxData: [ // 自定义列
				{
					label: "表格项：",
					showTitle:['openid','unionid','reg_time','user_ip','province','order_id','order_money','order_time','is_today_order','is_again','from_type','mp_campaign_id','creativeid','promotion_id','project_id','report_id_type','report_id','link_id','match_type_text','has_report','pass_reason','report_pay_time','supply_active_pay','cz'],
					custom_checkbox: true,
					type:"aa"
				},
				
			],
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth - 60 // 筛选条件大盒子的宽度
		
		function jsTable(){
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				nn = nn + res.width
			})
			that.table_scroll_width = nn + 30
			
			that.$nextTick(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
		}
		
		// 有自定义列缓存
		if(localStorage.getItem("table_custtom_orderGzh")){
			try{
				let s_title = JSON.parse(localStorage.getItem("table_custtom_orderGzh"))
				that.rableTitle.forEach(res=>{
					s_title.forEach(re_z=>{
						if(res.type == re_z.type){
							res.show_control = re_z.show_control
						}
					})
				})
				// 重新计算表格宽度
				that.computeTableWidth()
				// console.log("有自定义列缓存");
				// 同时计算一下自定义弹窗里的表格项是否为全选状态
				let i = 0
				that.rableTitle.forEach(res=>{
					if(!res.show_control){ // 如果有未选的，则取消全选状态
						i++
					}
				})
				if(i > 0){
					that.customCheckboxData[0].custom_checkbox = false
				}
			}catch(e){
				jsTable()
			}
		}
		else { // 没自定义列缓存
			// console.log("没自定义列缓存");
			jsTable()
		}
		
		
		// 修改母页面的tab选中状态
		that.$nextTick(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		})
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(7)
		that.startTime = this.$getThisDay()
		// 获取当前日期
		that.endTime = this.$getThisDay()
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		landPagePlatform().then(res=>{
			console.log('landPagePlatform',res);
			that.PlatformData = res.data.data.list
		})
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
				that.filterList = res.data.data.filter
				
				that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || [])
				// that.gzhFilterBlur = that.filterList.gzh_id.list || []
				// that.gzhFilterSearch = that.filterList.gzh_id.list || []
				// that.gzhFilterData = that.gzhFilterSearch.slice(that.gzh_page, that.gzh_limit) || []
				
				that.is_admin = res.data.data.is_admin
				
				// 搜索
				that.searchButton()
			}
			else if(res.data.code === 401){ // 未登录
				localStorage.removeItem("access_token");
				that.$router.replace({path: '/'})
			}
			else {
				that.$message.error(`错误：${res.data.msg}` || '其他错误，或许是参数问题');
			}

		})
	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			// 只能看今天和昨天的日期
			return current && current > moment().endOf('day') || current < moment().subtract(2,"days")
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		onChangeDateC(value, dateString){
			console.log('Selected Time: ', value);
			console.log('Formatted Selected Time: ', dateString);
			this.regStartDate = dateString[0]
			this.regEndDate = dateString[1]
		},
		onDateC_ok(value){
			// console.log('onOk: ', value);
		},
		
		handleChangeA(e){ // 渠道/书城
			console.log(e);
			this.r_channel_id = e
		},
		handleChangeB(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeC(e){ // 推广媒体
			console.log(e);
			this.r_platform = e
			
		},
		handleChangeD(e){ // 是否回传
			console.log(e);
			this.r_has_report = e
		},
		handleChangeE(e){ // 是否为注册当天订单
			console.log(e);
			this.r_is_today_order = e
		},
		handleChangeF(e){ // 是否匹配落地页
			console.log(e);
			this.r_is_has_link = e
		},
		handleChangeG(e){ // 是否首充
			console.log(e);
			this.r_is_again = e
		},
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		handleChangeTS(e){ // 选择投手
			this.r_admin_id = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				export: 0,
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				
				has_report: that.r_has_report, // 是否回传
				is_today_order: that.r_is_today_order, // 是否为注册当天订单
				is_has_link: that.r_is_has_link, // 是否匹配落地页
				is_again: that.r_is_again, // 是否首充
				
				admin_id: that.r_admin_id, // 投手
			}
			if(that.r_channel_id){ r_data.channel_id = that.r_channel_id } // 渠道id
			if(that.r_gzh_id){ r_data.gzh_id = that.r_gzh_id } // 公众号id
			if(that.r_platform){ r_data.platform = that.r_platform } // 推广媒体
			if(that.r_order_id){ r_data.order_id = that.r_order_id } // 订单ID
			if(that.r_link_id){ r_data.link_id = that.r_link_id } // 落地页ID
			if(that.r_creativeid){ r_data.creativeid = that.r_creativeid } // 创意ID
			if(that.r_ad_id){ r_data.ad_id = that.r_ad_id } // 计划ID(单元ID)
			if(that.r_promotion_id){ r_data.promotion_id = that.r_promotion_id }
			if(that.r_project_id){ r_data.project_id = that.r_project_id } 
			if(that.r_openid){ r_data.openid = that.r_openid }
			
			// 注册时间
			if(that.regStartDate){
				r_data.reg_start_date = that.regStartDate
			}
			if(that.regEndDate){
				r_data.reg_end_date = that.regEndDate
			}
			// 排序字段
			if(that.r_sort_field){
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			// 金额区间
			if(that.r_start_money || that.r_start_money == 0){
				r_data.start_money = that.r_start_money
			}
			if(that.r_end_money || that.r_end_money == 0){
				r_data.end_money = that.r_end_money
			}
			if(type != '导出'){
				orderGzhList(r_data).then(res=>{
					console.log('搜索',res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(type == '导出'){
				r_data.export = 1
				delete r_data.page
				delete r_data.limit
				orderGzhExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
			}
			else if(type == 2 || type == 3){ // 手动回传mp，adq
				this.hc_mp_adq_id = e.id
				this.hc_mp_adq_visible = true
			}
			
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			orderGzhReport({
				id: that.hc_id
			}).then(res=>{
				console.log("回传",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 手动回传mp，adq
		hcMpAdqOk(){
			let that = this
			that.hc_mp_adq_loading = true
			orderGzhMpAdq({
				id: that.hc_mp_adq_id
			}).then(res=>{
				console.log("回传mp，adq",res);
				that.hc_mp_adq_loading = false
				
				if(res.data.code == 0){
					that.hcMpAdqCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
			})
			.catch(err=>{
				that.hc_mp_adq_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcMpAdqCancel(){
			if(this.hc_mp_adq_loading){
				return
			}
			this.hc_mp_adq_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('点击表ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		// 导出
		exportButton(){
			let that = this
			
			
			that.searchButton('导出')
		},
		
		// 前往自建落地页用户表
		goLPzj(){
			// console.log("自建",this.$router.resolve('/LPzj'));
			let jump_url = ''
			if(this.h_report_id_type == 0){ // 自建落地页
				jump_url = '/LPzj'
			}
			else if(this.h_report_id_type == 1){ // 基木鱼
				jump_url = '/LPjmy'
			}
			else if(this.h_report_id_type == 3){ // 巨量点击检测
				jump_url = '/LPjl'
			}
			else if(this.h_report_id_type == 4){ // 微博点击检测
				jump_url = '/clickWeibo'
			}
			else if(this.h_report_id_type == 6){ // 快手落地页
				jump_url = '/LPks'
			}
			else {
				jump_url = '/LPzj'
			}
			const { href } = this.$router.resolve(jump_url)
			// console.log("href",href);
			window.open(href, '_blank');
		},
		
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				that.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton('button')
		},
		
		onChangeNumberS(e){ // 开始金额
			console.log(e);
			this.r_start_money = e
		},
		onChangeNumberE(e){ // 结束金额
			console.log(e);
			this.r_end_money = e
		},
		
		
		// 自定义列-表格————————
		onChangeSJ(e,index,d_tem){
			this.rableTitle[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			d_tem.showTitle.forEach(res=>{
				this.rableTitle.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			d_tem.custom_checkbox = ccccc
		},
		// 自定义列的小标题前的选择框
		checkboxCustom(e,d_tem){
			d_tem.custom_checkbox = e.target.checked
			
			this.rableTitle.forEach(res=>{
				d_tem.showTitle.forEach(d_es=>{
					if(res.type == d_es){
						if(e.target.checked){ // 要进行选中
							res.show_control = true
						}
						else {
							res.show_control = false
						}
					}
				})
			})
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 自定义列弹窗确认按钮
		customTd(){
			let s_data = []
			this.rableTitle.forEach(res=>{
				let obj = {
					type: res.type,
					show_control: res.show_control
				}
				s_data.push(obj)
			})
			localStorage.setItem("table_custtom_orderGzh",JSON.stringify(s_data));
			this.custtom_visible = false
		},
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			that.table_scroll_width = nn + 30
			// 有tab页的才需要这个---
			this.$nextTick(()=>{
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
		},
	},
	filters: {
		landPageFilter(value){
			let lll = ""
			if(value == 0){
				lll = "自建落地页表"
			}
			else if(value == 1){
				lll = "基木鱼用户表"
			}
			else if(value == 3){
				lll = "巨量点击表"
			}
			else if(value == 4){
				lll = "微博点击表"
			}
			return lll
		},
		matchTypeFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "未匹配"
			}
			else if(value == 1){
				mmm = "系统匹配"
			}
			else if(value == 2){
				mmm = "人工匹配"
			}
			else if(value == 3){
				mmm = "系统匹配：IP匹配"
			}
			else if(value == 4){
				mmm = "系统匹配：IP所在地匹配"
			}
			else if(value == 5){
				mmm = "系统匹配：设备ID匹配"
			}
			else if(value == 6){
				mmm = "用户注册表匹配"
			}
			return mmm
		},
		jumpUrlFilter(value){
			// console.log("value",value)
			let uuu = ''
			if(value == 0){
				uuu = "自建落地页"
			}
			else if(value == 1){
				uuu = "基木鱼"
			}
			else if(value == 3){
				uuu = "巨量点击检测"
			}
			else if(value == 4){
				uuu = "微博点击检测"
			}
			else if(value == 6){
				uuu = "快手落地页"
			}
			else {
				uuu = "自建落地页"
			}
			return uuu
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>